



























import { Vue, Component, Prop } from 'vue-property-decorator';
import utils from '@/services/utils';

@Component
export default class ActivityBody extends Vue {
  @Prop() readonly data!: object;

  @Prop() readonly type!: string;

  @Prop() readonly showDetail!: Function;

  @Prop() readonly paginationDetail!: object;

  utilsInstance = utils;

  handleShowDetail(id: string) {
    this.showDetail(id);
  }
}
